export default __webpack_public_path__ + "static/media/sandal.681ced26.jpeg";